import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RadioInlineText from 'components/atoms/Radio/Radio.inlineText';
import IconButton from 'components/atoms/Button/IconButton';
import { changeFontSize } from 'modules/actions/fontSize';
import { autoCompleteState } from 'modules/actions/autoComplete';
import { disableAllMenu } from 'modules/actions/statusMenu';
import PropTypes from 'prop-types';

const LeftSettingMenu = ({ styleDef }) => {
  /* font변경값 가져오기 */
  const currentFontSize = useSelector(state => state.fontSize.size);
  const autoCompleteStatus = useSelector(state => state.autoComplete.active);
  const dispatch = useDispatch();

  /* autoComplete on/off */
  const autoStatus = e => {
    sessionStorage.setItem('auto_active', e.target.value === 'on');
    dispatch(autoCompleteState(e.target.value === 'on'));
  };

  /* settingMenu 닫기 */
  const offSettingMenu = () => {
    dispatch(disableAllMenu());
  };

  /* font(변경)클릭시 action발생 */
  const textSizeChange = e => {
    sessionStorage.setItem('font_size', e.target.value);
    dispatch(changeFontSize(Number(e.target.value)));
  };
  return (
    <ul className="left_setting_area" style={styleDef}>
      <li className="left_setting_area_menu">
        폰트 크기 설정
        <div className="check_box" onChange={e => textSizeChange(e)}>

          <button type="button" style={{fontSize:'12px'}} className={`label ${currentFontSize === 12 ? "btncheck" : ""}`} title="폰트 크기 작게" value={12} onClick={e => textSizeChange(e)}>작게</button>
          <button type="button" style={{fontSize:'14px'}} className={`label ${currentFontSize === 14 ? "btncheck" : ""}`} title="폰트 크기 보통" value={14} onClick={e => textSizeChange(e)}>보통</button>
          <button type="button" style={{fontSize:'16px'}} className={`label ${currentFontSize === 16 ? "btncheck" : ""}`} title="폰트 크기 크게" value={16} onClick={e => textSizeChange(e)}>크게</button>
          
          {/* <input id="text_size_1" type="radio" name="text_size" value={12} defaultChecked={currentFontSize === 12} /> */}
          {/* <RadioInlineText tabindex="0" label="작게" value="text_size_1"/>
           */}
          {/* <label className="label" htmlFor="text_size_1" value={12}>작게</label> */}

          {/* <button type="button" className="label" value={12} onClick={e => textSizeChange(e)}>작게</button> */}

          {/* <input id="text_size_2" type="radio" name="text_size" value={14} defaultChecked={currentFontSize === 14} /> */}
          {/* <RadioInlineText tabindex="0" label="보통" value="text_size_2" /> */}
          {/* <button type="button" className="label" value={14} onClick={e => textSizeChange(e)}>보통</button> */}

          {/* <input id="text_size_3" type="radio" name="text_size" value={16} defaultChecked={currentFontSize === 16} /> */}
          {/* <button type="button" className="label" value={16} onClick={e => textSizeChange(e)}>크게</button> */}
          {/* <RadioInlineText tabindex="0" label="크게" value="text_size_3" /> */}
        </div>
      </li>

      <li className="left_setting_area_menu">
        자동 완성 설정
        <div className="check_box" onChange={e => autoStatus(e)}>
        {/* <button type="button" className={`label ${currentFontSize === 16 ? "btncheck" : ""}`} value={16} onClick={e => textSizeChange(e)}>크게</button> */}
          
          <button type="button" className={`label ${autoCompleteStatus === true ? "btncheck" : ""}`} title="자동완성 설정 켜기" value="on" onClick={e => autoStatus(e)}>켜기</button>
          <button type="button" className={`label ${autoCompleteStatus !== true ? "btncheck" : ""}`} title="자동완성 설정 끄기" value="off" onClick={e => autoStatus(e)}>끄기</button>

          {/* <input id="autoCom_1" type="radio" name="autoCom" value="on" defaultChecked={autoCompleteStatus === true} /> */}
          {/* <button type="button" className="label" value="on" onClick={e => autoStatus(e)}>켜기</button> */}
          {/* <RadioInlineText label="켜기" value="autoCom_1" /> */}
          {/* <input id="autoCom_2" type="radio" name="autoCom" value="off" defaultChecked={autoCompleteStatus !== true} /> */}
          {/* <button type="button" className="label" value="of" onClick={e => autoStatus(e)}>끄기</button> */}

          {/* <RadioInlineText label="끄기" value="autoCom_2" /> */}
        </div>
      </li>
      <div onClick={() => offSettingMenu()}>
        <li className="left_setting_area_menu">
          닫기
          <IconButton icon="ri-close-line-2" styleDef={{}} viewStatus="" title="화면 설정 닫기" />
        </li>
      </div>
    </ul>
  );
};

LeftSettingMenu.propTypes = {
  styleDef: PropTypes.object,
};
LeftSettingMenu.defaultProps = {
  styleDef: {},
};
export default LeftSettingMenu;
